import { MembershipType } from "../api/dtos";

const getMembershipTypeText = (type?: MembershipType): string => {

    switch (type) {
        case MembershipType.Affiliate:
            return "Affiliate Member";
        case MembershipType.Full:
            return "Full Member";
        case MembershipType.Life:
            return "Life Member";
        default:
            return "Non-Member";
    }
}
export default getMembershipTypeText;